import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { FacilityRcraProfileInput } from "generated-graphql/graphql";
import { useCallback } from "react";

const VALIDATE_FACILITY_RCRA_PROFILE_INPUT = gql(`
  query ValidateFacilityRcraProfileInput(
    $facilityId: ID!
    $data: FacilityRcraProfileInput!
  ) {
    facilityRcraProfileInputValidator(facilityId: $facilityId, data: $data) {
      ...issue
    }
  }
`);

export function useFacilityRcraProfileInputValidation(facilityId: string | undefined) {
  const [query] = useLazyQuery(VALIDATE_FACILITY_RCRA_PROFILE_INPUT, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (input: FacilityRcraProfileInput) => {
      if (!facilityId) return [];
      const { data } = await query({ variables: { facilityId, data: input } });
      return data?.facilityRcraProfileInputValidator ?? [];
    },
    [facilityId, query]
  );
}
